export const OutletTypes = {
  GUI: "gui",
  EDITOR: "editor",
};